import React, { useState, useEffect } from 'react';

const ApiCreated = props => {
    const [ token, setToken ] = useState('');
    useEffect(() => {
        _fetchData();
    },[]);

    const _fetchData = () => {
        setToken(props.match.params.key)
    };

    return (
        <div className="text-center p-4 container bg-white rounded shadow">
            <div>
                <h4><i className="fas fa-key mr-3"></i>Kunci API Terbuat</h4>
            </div>
            <br/>
            <br/>
            <p className="mb-0"> Mohon dicopy dan disimpan di tempat aman.</p>
            <p className="text-danger"> Demi keamanan, kami tidak dapat menampilkannya kembali.</p>
            <br/>
            <div className="bg-lighter text-wrap p-4 border rounded">
                <p className="mb-0"><b>{token}</b></p>
            </div>
            <br/>
            <button
                className="btn btn-primary btn-sm"
                onClick={() => window.location.assign('/integrations')}
            >
                Selesai
            </button>
        </div>
    )
};

export default ApiCreated;